module.exports = __webpack_public_path__ + "img/6.b2c74c73.png";